module.exports = __webpack_public_path__ + "img/77.80dc9f47.svg";